import React, { useEffect, useState, useRef } from 'react';
import './PostingCreateTabs.css';
import ApplicantCardNew from '../../../components/ApplicantCardNew/ApplicantCardNew';
import { Grid, Chip } from '@mui/material';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../components/Loader/Loader';
import * as _ser from '../../../_redux/_services/JobPostingSlice';
import { decrypt } from '../../../_utilities/_encryptDecryptHelper';
import GetJobId from '../../../_utilities/GetJobId';
import { updateApplicantId } from '../../../_redux/SeletedapplicantIdsSlice';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import { getAttributes, GetUserInfo } from '../../../_utilities/getUserInfo';
const initalState = { data: null, message: '', isloader: true };

const RecommendedTalent = ({ getjobDetails = null, onReceiveData }) => {
  const [matchedApplicants, setMatchedApplicants] = useState([]);
  const [skillsData, setSkillsData] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [jobDetails, setJobDetails] = useState(getjobDetails);
  const [expanded, setExpanded] = useState(false);
  const [showSkillsToggleBtn, setShowSkillsToggleBtn] = useState(false);
  const skillcontainer = useRef(null);
  const JobId = GetJobId();
  const showLoader = useSelector((state) => state.Loader);
  const SearchAffinda = useSelector((state) => state.SearchAffinda.data);
  const AddAssociatedjobsCode = useSelector(
    (state) => state.AddAssociatedjobs.data
  );
  const DelAssociatedJobcode = useSelector(
    (state) => state.DeleteAssociatedJob.data
  );
  const getDetails = useSelector((state) => state.Jobpostingsbyid.data);
  const getApplicantIds = useSelector(
    (state) => state.SeletedApplicantIds.value
  );
  const [selectedAppliants, setSelectedAppliants] = useState([]); //getApplicantIds && getApplicantIds?.length > 0 ? getApplicantIds :

  const [userInfo, setUserInfo] = useState([]);
  const [userId, setUserId] = useState([]);

  useEffect(() => {
    const loadUser = async () => {
      const userinfo = await GetUserInfo();
      const attribute = await getAttributes();
      setUserInfo(userinfo);
      setUserId(attribute);
    };

    loadUser();
  }, []);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!getjobDetails) {
      if (!JobId) {
        return;
      }
      dispatch(_ser.jobpostingsbyidAsync(JobId));
    }
  }, [getjobDetails]);

  useEffect(() => {
    if (getDetails !== null && getDetails !== undefined) {
      let postingData = JSON.parse(JSON.stringify(getDetails));
      postingData.jobType = postingData.jobType.split(',');
      postingData.recruiters = postingData?.recruiters
        ? JSON.parse(postingData.recruiters)
        : [];
      postingData.clientName = {
        id: postingData?.clientId,
        clientName: postingData?.clientName,
      };
      setJobDetails(postingData);
      localStorage.setItem('JobIdentifier', postingData.affindaIdentifier);
      dispatch(_ser.jobpostingsbyidStartReducer(initalState));
    }
  }, [getDetails]);

  const fetchMatchedApplicants = async () => {
    let jobIdentifier = localStorage.getItem('JobIdentifier');
    if (jobIdentifier !== 'null') {
      let obj = { limit: 50, offset: 1 };
      dispatch(_ser.searchAffindaAsync(obj, jobIdentifier));
    }
  };

  const checkHeight = () => {
    if (!skillcontainer.current) return;
    const skillContainerHeight = skillcontainer.current.clientHeight;
    setShowSkillsToggleBtn(skillContainerHeight > 60 ? true : false);
  };

  // Track changes using MutationObserver
  useEffect(() => {
    if (!skillcontainer.current) return;
    const observer = new MutationObserver(() => {
      console.log('ComponentData updated!');
      checkHeight(); // Recalculate height on content change
    });

    observer.observe(skillcontainer.current, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect(); // Cleanup observer on unmount
  }, []);

  useEffect(() => {
    fetchMatchedApplicants();
  }, []);

  useEffect(() => {
    if (jobDetails) {
      setSkillsData(
        jobDetails?.primarySkills
          ? jobDetails.primarySkills
              .replace(/\r?\n/g, ',')
              .split(',')
              .map((skill) => skill.trim())
              .filter(Boolean)
          : []
      );
      setCustomFields(
        jobDetails?.customFields ? JSON.parse(jobDetails?.customFields) : []
      );
    }
  }, [jobDetails]);

  useEffect(() => {
    if (SearchAffinda !== null && SearchAffinda !== undefined) {
      setMatchedApplicants([]);
      if (SearchAffinda.length > 0) {
        const myData = [];
        let applicantsData = JSON.parse(JSON.stringify(SearchAffinda));
        applicantsData.forEach((e) => {
          if (e.skills) {
            const destructerSkils =
              JSON.parse(e.skills)?.map((x) => x.name) ?? [];
            const list = destructerSkils.filter((skill) => {
              const firstWord = skill.split(' ')[0].toLowerCase();
              return skillsData.some((s) =>
                firstWord.startsWith(s.slice(0, 3).toLowerCase())
              );
            });
            e['matchedSkills'] = list;
          }
          myData.push(e);
        });

        setMatchedApplicants(myData);
        dispatch(_ser.searchAffindaStartReducer(initalState));
      } else {
        setMatchedApplicants([]);
      }
    }
  }, [SearchAffinda]);

  const onActionHandler = (item, type) => {
    let modifyData = [...selectedAppliants];
    let Index = modifyData.findIndex((x) => x.id === item.id);
    if (Index !== -1) {
      modifyData.splice(Index, 1);
    } else {
      modifyData.push(item);
    }
    setSelectedAppliants(modifyData);
    let obj = {
      id: parseInt(item.id),
      applicantCode: item.applicantCode,
      docId: item.docsId,
      score: item?.score ? item.score : '',
      source: item.source,
      userId: item.userId,
      submittedBy: userInfo[0].id,
      firstName: userId[0].firstName,
      lastName: userId[0].lastName,
      status: 'Associated',
    };
    if (type === 'Add') {
      dispatch(_ser.addAssociatedjobsAsync(jobDetails?.id, obj, 'applicant'));
    } else {
      let data = {};
      dispatch(_ser.deleteAssociatedJobAsync(jobDetails?.id, obj, data));
    }
    dispatch(updateApplicantId(modifyData));
  };

  useEffect(() => {
    if (AddAssociatedjobsCode === 200 || DelAssociatedJobcode === 200) {
      dispatch(_ser.addAssociatedjobsStartReducer(initalState));
      dispatch(_ser.deleteAssociatedStartReducer(initalState));
    }
  }, [AddAssociatedjobsCode, DelAssociatedJobcode]);

  return (
    <>
      <div className="talent-header-section">
        <h1>
          {jobDetails?.jobTitle}
          {/* <span>{(() => { const exp = customFields?.find(x => x.key === "Experience")?.value; return exp ? `${parseInt(exp)} Exp` : "";})()}</span> */}
          <span>
            {(() => {
              const v = customFields?.find(
                (f) => f.key === 'Experience'
              )?.value;
              const n = Number(Array.isArray(v) ? v[0] : v);
              return Number.isFinite(n) ? `${n} Exp` : '';
            })()}
          </span>
        </h1>
        {jobDetails?.location ? (
          <p>
            <LocationOnIcon />
            {jobDetails.location}
          </p>
        ) : (
          ''
        )}
        {jobDetails?.jobType ? (
          <p>
            <AccessTimeFilledIcon />
            {Array.isArray(jobDetails.jobType)
              ? jobDetails.jobType.length > 0
                ? jobDetails.jobType.join(', ')
                : ''
              : jobDetails.jobType}
          </p>
        ) : (
          ''
        )}
        <div
          style={{ height: expanded ? 'initial' : '60px', overflow: 'hidden' }}
        >
          <div
            ref={skillcontainer}
            style={{ display: 'flex', flexWrap: 'wrap', gap: 6, mt: 1 }}
          >
            {skillsData.map((skill, idx) => (
              <Chip key={idx} label={skill} size="small" />
            ))}
          </div>
        </div>
        {showSkillsToggleBtn && (
          <span
            style={{
              float: 'right',
              alignSelf: 'center',
              marginTop: '-7px',
              textTransform: 'none',
              color: '#000000ff',
              textDecoration: 'underline',
              cursor: 'pointer',
              ':hover': {
                background: 'none',
                textDecoration: 'underline',
                cursor: 'pointer',
              },
            }}
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? (
              <>
                Show less{' '}
                <ExpandLessIcon
                  fontSize="small"
                  sx={{
                    mt: 0.8,
                    color: '#ffffffff',
                    border: '1px solid',
                    borderColor: '#000000ff',
                    bgcolor: '#000000ff',
                    borderRadius: '50%',
                    width: 14,
                    height: 14,
                  }}
                />
              </>
            ) : (
              <>
                View all{' '}
                <ExpandMoreIcon
                  fontSize="small"
                  sx={{
                    mt: 0.8,
                    color: '#ffffffff',
                    border: '1px solid',
                    borderColor: '#000000ff',
                    bgcolor: '#000000ff',
                    borderRadius: '50%',
                    width: 14,
                    height: 14,
                  }}
                />
              </>
            )}
          </span>
        )}
      </div>
      <div className="talent-body-section">
        <h1>Matching Applicants</h1>
        <p>
          Found {matchedApplicants?.length} applicants matching your job
          requirements
        </p>
        <Grid container spacing={3}>
          {showLoader.uncommonUpdateLoader ? <Loader /> : ''}
          {matchedApplicants && matchedApplicants.length > 0 ? (
            <ApplicantCardNew
              data={matchedApplicants}
              selectedApplicantIds={selectedAppliants?.map((x) => x.id) ?? []}
              onReceiveProps={(selectedItem, type) =>
                onActionHandler(selectedItem, type)
              }
            />
          ) : (
            !showLoader.uncommonUpdateLoader && (
              <div>
                <div className="nodatasection nodataSection">
                  <img
                    src={process.env.PUBLIC_URL + '/assests/nodata.svg'}
                    alt="noResult"
                  />
                  No matching Applicants
                </div>
              </div>
            )
          )}
        </Grid>
      </div>
    </>
  );
};

export default RecommendedTalent;
